

























































































import { Meta } from "@/store/meta"
import { Vue, Component } from "vue-property-decorator"
import { Server } from '@/store/server'
import { getModule } from "vuex-module-decorators"
import ConfirmModal from '@/components/ConfirmModal.vue'
import AlertModal from '@/components/AlertModal.vue'

@Component({
  components: {
      'confirm-modal': ConfirmModal,
      'alert-modal': AlertModal
  }
})

export default class Contact extends Vue {
  inputTitle = ''
  inputContent = ''

  // modal
  isConfirmModalActive = false
  isAlertModalActive = false
  alertContent = ''
  checkContents = [{}]

  get meta() {
    return getModule(Meta)
  }
  get server() {
    return getModule(Server)
  }

  alertModal(alertContent = ''){
    this.alertContent = alertContent
    this.isAlertModalActive = true
  }

  async postContactsCheck(){
    if(!this.inputTitle){
      this.alertModal('件名を入力してください。')
      return
    }else if(!this.inputContent){
      this.alertModal('内容を入力してください。')
      return
    }

    this.checkContents.splice(0)
    this.checkContents.push({title:'件名', value:this.inputTitle})
    this.checkContents.push({title:'内容', value:this.inputContent})
    this.isConfirmModalActive = true
    
    return
  }

  async postContacts(title: string, content: string){
    const sendData: string[] = [title, content];
    try {
      await this.server.postContacts(sendData)
      this.$router.push({ path: 'contact/sent' , query :{ success: 'true' }});
    } catch (e) {
      this.$router.push({ path: 'contact/sent' , query :{ success: 'false' }});
    } 
    
  }
}
